import { IconButton, InputAdornment, TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { Search, X } from 'lucide-react';
import type { InputHTMLAttributes } from 'react';

type SearchInputProps = {
    value: string;
    onChange: (newValue: string) => void;
    placeholder: string;
    /** Accessible name of the clear control, shown while there is text to clear. */
    clearLabel: string;
    inputProps?: InputHTMLAttributes<HTMLInputElement> & {
        'aria-label'?: string;
        'data-testid'?: string;
    };
    fullWidth?: boolean;
    sx?: SxProps<Theme>;
};

/** Outlined search field with a leading glass and, once there is text, a clear control. */
export default function SearchInput({
    value,
    onChange,
    placeholder,
    clearLabel,
    inputProps,
    fullWidth = false,
    sx,
}: SearchInputProps) {
    return (
        <TextField
            fullWidth={fullWidth}
            sx={sx}
            inputProps={inputProps}
            size="small"
            variant="outlined"
            placeholder={placeholder}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Search size={14} />
                    </InputAdornment>
                ),
                endAdornment: value !== '' && (
                    <InputAdornment position="end">
                        <IconButton
                            size="small"
                            edge="end"
                            aria-label={clearLabel}
                            onClick={() => onChange('')}
                        >
                            <X size={14} />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
}
